export const numberFormats = {
  fallbackLocale: 'es-MX',
  locale: 'es-MX',
  'es-MX': {
    currency: {
      style: 'currency',
      currency: 'MXN',
      currencyDisplay: 'symbol'
    },
    integer: {
      style: 'decimal',
      currency: 'MXN',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    decimal: {
      style: 'decimal',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  },
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'symbol'
    },
    integer: {
      style: 'decimal',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    decimal: {
      style: 'decimal',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }
  }
}
